/* eslint-disable react/function-component-definition */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import type { FaixaDePreco } from '../../../../../@types/IPA/PrecoPsicologico';
import { ButtonVideo } from '../../../../ISA/InfoPanel/AnaliseCompetitividade/Components';
import { ModalTutorialVideo } from '../ModalTutorialVideo';

interface Props {
  faixas: FaixaDePreco[];
}

export function PrecoPsicologicoHeader({ faixas }: Props) {
  const history = useHistory();
  const [mostrarTutorial, setMostrarTutorial] = useState(false);

  const ultimaAtualizacao = React.useMemo(() => {
    if (faixas.length === 0) return undefined;
    const datas = faixas
      .map(f => f.atualizadoEm ?? f.criadoEm)
      .filter(Boolean)
      .sort();
    return datas[datas.length - 1];
  }, [faixas]);

  const dataFormatada = ultimaAtualizacao ? new Date(ultimaAtualizacao).toLocaleDateString('pt-BR') : '--';

  return (
    <>
      <div className="pp-header">
        <div className="pp-header__row">
          <span className="pp-header__titulo">Regra de preço psicológico</span>
          <div className="pp-header__aviso">
            <svg className="pp-header__aviso-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M1 21L12 2l11 19H1zm11-3h2v-2h-2v2zm0-4h2v-4h-2v4z" />
            </svg>
            <span className="pp-header__aviso-texto">As alterações serão aplicadas na próxima integração de dados</span>
          </div>
          <div className="pp-header__cta">
            <ButtonVideo onClick={() => setMostrarTutorial(true)} />
          </div>
        </div>
        <div className="pp-header__data">Última atualização: {dataFormatada}</div>
      </div>

      <ModalTutorialVideo show={mostrarTutorial} onHide={() => setMostrarTutorial(false)} />

      <div
        style={{
          background: '#0D66D0',
          color: '#fff',
          padding: '12px 20px',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '16px 0',
          fontSize: 14,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#FBBF24" style={{ flexShrink: 0 }}>
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
          <span>
            A versão antiga do Preço Psicológico ainda está configurada como padrão para esta conta. Suas regras já foram copiadas para cá: você pode conferir e
            passar a usar o layout mais simples de configurar faixas de preço quando quiser.
          </span>
        </div>
        <button
          type="button"
          onClick={() => history.push('/administrador/produtos/IPA/configuracoes-basicas')}
          style={{
            background: '#33AB84',
            border: 'none',
            color: '#fff',
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: 0.5,
            padding: '8px 16px',
            borderRadius: 4,
            cursor: 'pointer',
            marginLeft: 16,
          }}
        >
          TORNAR PADRÃO
        </button>
      </div>
    </>
  );
}
